export default __webpack_public_path__ + "static/media/costing-active.4579eb26.svg";